import {Module} from "vuex";
import {RootState} from "@/store/types";
import {CompareState} from "./types";


const CompareModule: Module<CompareState, RootState> = {
    namespaced: true,
    state: {
        showCompareProductSelect: false
    },
    getters: {
        getShowCompareProductSelectModal(state){
            return state.showCompareProductSelect;
        }
    },
    mutations: {
        setShowCompareProductSelectModal(state){
            state.showCompareProductSelect = true;
        },
        setHideCompareProductSelectModal(state){
            state.showCompareProductSelect = false;
        }
    },
    actions: {
        showCompareProductSelectModal({commit}){
            commit('setShowCompareProductSelectModal');
        },
        hideCompareProductSelectModal({commit}){
            commit('setHideCompareProductSelectModal');
        }
    }
}

export default CompareModule;

